import React, { FC, useState } from 'react'
import { Stack } from 'components/Stack'
import { SelectInput } from 'components/SelectInput'
import { useTranslation } from 'react-i18next'
import { RegionFormParams } from 'models/region'
import { Button } from 'components/Button'
import { Region } from 'models/region'
import { SelectOptionAdapter } from 'utils/selectOption'
import {
  useFetchCountries,
  useFetchStates,
  useFetchMunicipalities,
  useFetchAreas,
} from 'services/region'
import { SelectOption } from 'components/SelectInput/SelectInput'
import { Alert } from 'components/Alert'

type RegionFormProps = {
  // Selected
  country?: Region
  state?: Region
  state2?: Region
  state3?: Region
  municipality?: Region
  city?: Region
  type?: string
  // Form
  submitArea: (area: RegionFormParams) => void
  status?: string
}

const { buildOption, buildOptions } = SelectOptionAdapter('id', 'label')

export const RegionForm: FC<RegionFormProps> = (props) => {
  const { t } = useTranslation()
  const [country, setCountry] = useState(props.country && buildOption(props.country))
  const [state, setState] = useState(props.state && buildOption(props.state))
  const [state2, setState2] = useState(props.state2 && buildOption(props.state2))
  const [state3, setState3] = useState(props.state3 && buildOption(props.state3))
  const [municipality, setMunicipality] = useState(
    props.municipality && buildOption(props.municipality),
  )
  const [area, setArea] = useState(props.city && buildOption(props.city))

  const { countries = [] } = useFetchCountries()
  // TODO: Remove this when we allow multiple countries
  const { states = [] } = useFetchStates(country?.value.toString())
  const { municipalities = [] } = useFetchMunicipalities(state?.value)
  const { areas = [] } = useFetchAreas(municipality?.value)

  // TODO: Remove this when we allow multiple countries
  // useEffect(() => {
  // const defaultCountry = countries.find((c: Region) => c.id === 1)
  //if (defaultCountry) {
  // setCountry({ label: defaultCountry.label, value: defaultCountry.id })
  // }
  //}, [countries])

  const onCountryChange = (country?: SelectOption) => {
    setCountry(country)
    setState(undefined)
    setMunicipality(undefined)
    setArea(undefined)
  }

  const onStateChange = (newState?: SelectOption) => {
    setState(newState)
    setMunicipality(undefined)
    setArea(undefined)
  }

  const onMunicipalityChange = (municipality?: SelectOption) => {
    setMunicipality(municipality)
    setArea(undefined)
  }

  const onCountryChange2 = (country?: SelectOption) => {
    setCountry(country)
    setState(undefined)
    setMunicipality(undefined)
    setArea(undefined)
  }

  const onStateChange2 = (newState?: SelectOption) => {
    setState(newState)
    setMunicipality(undefined)
    setArea(undefined)
  }

  const onMunicipalityChange2 = (municipality?: SelectOption) => {
    setState2(municipality)
    setArea(undefined)
  }

  const onAreaChange2 = (region?: SelectOption) => {

    setState3(region)
  }


  const handleAreaSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    var estado = state?.value
    var estado2 = state2?.value
    var estado3 = state3?.value
    if (estado2 === undefined) {
      estado2 = estado
      estado3 = estado
    }
    if (estado3 === undefined) {
      estado3 = estado
    }
    event.preventDefault()
    props.submitArea({
      countryId: country?.value,
      stateId: estado,
      stateId2: estado2,
      stateId3: estado3,
      municipalityId: municipality?.value,
      cityId: area?.value,
    })
  }


  /*const handleAreaSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    props.submitArea({
      countryId: country?.value,
      stateId: state?.value,
      stateId2: state2?.value,
      stateId3: state3?.value,
      municipalityId: municipality?.value,
      cityId: area?.value,
    })
  }*/

  if (props.type === "1") {
    return (
      <Stack space="medium">
        <form onSubmit={handleAreaSubmit}>
          <Stack space="medium">
            <SelectInput
              label={t('region_form.country')}
              options={buildOptions(countries)}
              onChange={onCountryChange2}
              value={country}
            />

            <SelectInput
              label={t('region_form.state')}
              options={buildOptions(states)}
              onChange={onStateChange2}
              value={state}
            />

            <SelectInput
              label={t('region_form.state')}
              options={buildOptions(states)}
              onChange={onMunicipalityChange2}
              value={state2}
            />

            <SelectInput
              label={t('region_form.state')}
              options={buildOptions(states)}
              onChange={onAreaChange2}
              value={state3}
            />

            <Button type="submit" loading={props.status === 'loading'}>
              {t('region_form.cta')}
            </Button>
          </Stack>
        </form>

        {props.status === 'success' && (
          <Alert tone="positive" full>
            {t('common.messages.success')}
          </Alert>
        )}

        {props.status === 'error' && (
          <Alert tone="critical" full>
            {t('common.messages.error')}
          </Alert>
        )}
      </Stack>
    )
  }


  return (
    <Stack space="medium">
      <form onSubmit={handleAreaSubmit}>
        <Stack space="medium">
          <SelectInput
            label={t('region_form.country')}
            options={buildOptions(countries)}
            onChange={onCountryChange}
            value={country}

          />

          <SelectInput
            label={t('region_form.state')}
            options={buildOptions(states)}
            onChange={onStateChange}
            value={state}
          />

          <SelectInput
            label={t('region_form.municipality')}
            options={buildOptions(municipalities)}
            onChange={onMunicipalityChange}
            value={municipality}
          />

          <SelectInput
            label={t('region_form.city')}
            options={buildOptions(areas)}
            onChange={setArea}
            value={area}
          />

          <Button type="submit" loading={props.status === 'loading'}>
            {t('region_form.cta')}
          </Button>
        </Stack>
      </form>

      {props.status === 'success' && (
        <Alert tone="positive" full>
          {t('common.messages.success')}
        </Alert>
      )}

      {props.status === 'error' && (
        <Alert tone="critical" full>
          {t('common.messages.error')}
        </Alert>
      )}
    </Stack>
  )
}

RegionForm.displayName = 'RegionForm'
